import React from 'react';
import Button from '@material-ui/core/Button';

const ButtonPrimary = (props) => {
  return <Button variant="contained" color="primary" {...props} />;
};

export default ButtonPrimary;
